import React from "react";
import { Breadcrumbs, Link } from "@mui/material";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import styles from "../../styles/pageHeader/index.module.scss";

const DynamicBreadcrumbs = ({ 
  items, 
  separator = <ChevronRightIcon className="icon-small" />, 
}) => {
  
  const renderItem = (item) => {
    return item.icon || item.label;
  };

  return (
    <Breadcrumbs 
      separator={separator} 
      aria-label="breadcrumb" 
      className={`${styles.breadcrumbs}`}
    >
      {
        items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            isLast ? (
              <p key={`breadcrumb_${index}`}>
                {item.label}
              </p>
            ) : (
              (item.href || item.onClick) ? (
              <Link
                key={`breadcrumb_link_${index}`}
                color="inherit"
                href={item.href}
                underline="hover"
                onClick={item.onClick}
                className={`${styles.breadcrumbs} cursor-pointer`} 
              >
                {renderItem(item)}
              </Link>
              ) : (
                <React.Fragment key={`breadcrumb_fragment_${index}`}>
                  {renderItem(item)}
                </React.Fragment>
              )
            )
          )
        })
      }
    </Breadcrumbs>
  );
};

export default DynamicBreadcrumbs;
